// extracted by mini-css-extract-plugin
export default {"root":"WatchlistName_root__Xqoiv","actions":"WatchlistName_actions__bh3bN","button":"WatchlistName_button__uwRqp"};